// extracted by css-extract-rspack-plugin
module.exports =  {"title":"BulkArchiveBundleDialog__title___GDdIs","count":"BulkArchiveBundleDialog__count___VOVZg","description":"BulkArchiveBundleDialog__description___ywqTz"};